import { LayoutDefinition } from './layout'

// Keyed by tab id; a tab absent from here starts empty.
export const WINDOW_DEFAULTS: Partial<Record<string, LayoutDefinition>> = {
  medicalRecord: {
    panels: [
      { panel: 'basicDetails', span: 'full' },
      { panel: 'ethnicity', span: 'full' },
      { panel: 'occupation', span: 'full' },
      { panel: 'education', span: 'full' },
      { panel: 'locationCredentialing', span: 'full' },
      { panel: 'shippingInfo', span: 'full' },
      { panel: 'emergencyContact', span: 'full' },
      { panel: 'billingInfo', span: 'full' },
      { panel: 'primaryCareProvider', span: 'full' },
      { panel: 'consentDocuments', span: 'full' },
      { panel: 'participantHistory', span: 'full' },
    ],
  },
}
